import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { Link } from "react-router-dom";
import { cardData, categoryData } from "../../constant/fake-data";
import Button from "../../components/Button/index";




const Category = () => {
  return (
    <div>
      <Header />

            <Banner
        title="Category"
        bgImage={IMAGES.ContactUsBannerbg}
        breadcrumbs={["Category"]}
      />

            <section className="category-slider category-grid">
<div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="text">
          <div className="bottom-line bottom-line-non">
            <h2>
              Auction <span>Category</span>
            </h2>
          </div>
        </div>

        <div className="row">
          {categoryData.map((cat) => (
            <div className="col-md-2 col-sm-4 col-6 mb-4" key={cat.id}>
              <Link
                to={`/category/${cat.name.toLowerCase()}`}
                style={{
                  display: "block",
                  textAlign: "center",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "1rem",
                  background: "#fff",
                  textDecoration: "none",
                  color: "#000",
                  height: "100%",
                }}
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  style={{
                    width: "100%",
                    height: "150px",
                    objectFit: "contain",
                    marginBottom: "0.5rem",
                  }}
                />
                <h3 style={{ fontSize: "1rem", marginBottom: "0.3rem" }}>
                  {cat.name}
                </h3>
                <p style={{ margin: 0 }}>{cat.items}</p>
              </Link>
            </div>
          ))}
        </div>

        <div className="t-btn-center mt-4">
          <Button
            text="View All Auctions"
            primary={true}
            icon={true}
            onClick={() => console.log("View All Auctions clicked")}
            style={{ fill: "black" }}
          />
        </div>
      </div>
    </div>
  </div>
      </section>

      <Footer />
    </div>
  );
};

export default Category;
